var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1648_193860",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1648_193860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7225 32H25.8064C26.4258 32 26.8387 32.4091 26.8387 33.0228V57.9773C26.8387 58.5908 26.4258 59 25.8064 59H1.03226C0.412903 59 0 58.5908 0 57.9773V33.2273C0 17.6818 10.529 5 25.8064 5C26.4258 5 26.8387 5.4091 26.8387 6.02273V17.2728C26.8387 17.8863 26.4258 18.2954 25.8064 18.2954C21.6775 18.2954 15.6903 23.8181 15.6903 30.9773C15.6903 31.5909 16.1033 32 16.7225 32ZM53.8839 32H62.9677C63.587 32 64 32.4091 64 33.0228V57.9773C64 58.5908 63.587 59 62.9677 59H38.1935C37.5742 59 37.1613 58.5908 37.1613 57.9773V33.2273C37.1613 17.6818 47.6903 5 62.9677 5C63.587 5 64 5.4091 64 6.02273V17.2728C64 17.8863 63.587 18.2954 62.9677 18.2954C58.8387 18.2954 52.8516 23.8181 52.8516 30.9773C52.8516 31.5909 53.2645 32 53.8839 32Z",
    fill: "url(#paint0_linear_1648_193860)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1648_193860",
    x1: 0,
    y1: 5,
    x2: 64,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6943FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FE5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quote-icon.1181cf0f612b327cc9cd4a7d648781f5.svg";
export { ForwardRef as ReactComponent };